export default "__VITE_ASSET__6506355c__"